import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import React, { useContext, useState } from 'react';
import { langs } from '@uiw/codemirror-extensions-langs';
import styled, { css } from 'styled-components';
import Keywords from 'react-keywords';
import { Input } from './Input';
import { Context } from '../../store/content';
import { ArrorRightIcon } from '../icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Warpper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  padding: 0.5rem 0.5rem 0.5rem 0.5rem;\n  display: flex;\n  flex-direction: column;\n  user-select: none;\n  gap: 0.2rem;\n  position: relative;\n"])));
var Header = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  background-color: var(--color-ci-btn-bg);\n  border-radius: 0.2rem;\n  display: inline-block;\n  padding: 0.1rem 0.3rem;\n"])));
var LanguageItem = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  padding: 0.3rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  &::after {\n    content: ' ';\n    display: block;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    cursor: pointer;\n    background-color: var(--color-ci-btn-hover-bg);\n    border-radius: 0.2rem;\n    opacity: 0;\n    transition: all 0.2s;\n  }\n  &:hover::after {\n    opacity: 0.2;\n  }\n  &:active::after {\n    opacity: 0.3;\n  }\n  ", "\n"])), props => props.active && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      ", " {\n        background-color: #00ea015e;\n      }\n    "])), Header));
export var LanguageView = () => {
  var {
    lang,
    setLang
  } = useContext(Context);
  var [search, setSearch] = useState('');
  var handleClick = ev => {
    setLang(ev.currentTarget.dataset.theme);
  };
  var handleSearch = ev => {
    setSearch(ev.target.value);
  };
  var filter = keyname => {
    return new RegExp("" + search, 'gi').test(keyname);
  };
  return /*#__PURE__*/_jsxs(Warpper, {
    children: [/*#__PURE__*/_jsx(Input, {
      type: "search",
      value: search,
      onChange: handleSearch
    }), Object.keys(langs).filter(filter).map((keyname, index) => {
      return /*#__PURE__*/_jsxs(LanguageItem, {
        active: keyname === lang,
        "data-theme": keyname,
        onClick: handleClick,
        children: [/*#__PURE__*/_jsx(Header, {
          children: /*#__PURE__*/_jsx(Keywords, {
            value: search,
            children: keyname
          })
        }), keyname === lang && /*#__PURE__*/_jsx(ArrorRightIcon, {
          width: 15,
          height: 15
        })]
      }, index);
    })]
  });
};